import React from "react";
import { Typography, Box } from "@mui/material";
import { Folder as FolderIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const MainSidebarHeader = () => {
  const { t } = useTranslation();
  const translation = t("fileExplorer");
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        px: 2, // Consistent padding
        py: 0, // Remove vertical padding to match main header
      }}
    >
      <FolderIcon sx={{ color: "#FFB300", mr: 1.5, fontSize: 24 }} />
      <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
        {translation.fileManager}
      </Typography>
    </Box>
  );
};

export default MainSidebarHeader;
